import React from 'react'
import OrderDetailContainer from 'containers/panel/admin/order-detail-container'


const OrderDetailPage = () => {
  return (
    <OrderDetailContainer/>
  )
}

export default OrderDetailPage